import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

//libraries
import { Helmet } from "react-helmet-async";

//styles
import "./HomeScreen.scss";

//components
import Testimonials from "./Testimonials/Testimonials.jsx";
import CallButton from "../../components/DiscoveryButton/CallButton.jsx";
import Map from "../../components/GoogleMap/Map.jsx";
import Partners from "../../components/Partners/ProudPartners.jsx";
import Modal from "../../components/Modal/Modal.jsx";
import Hero from "./Hero/Hero.jsx";
import MainContent from "./MainContent/MainContent.jsx";

const HomeScreen = () => {
  const location = useLocation();
  const [submissionStatus, setSubmissionStatus] = useState({
    heading: "Welcome",
    message: "Book a FREE Discovery Call with Dr. Wade!",
    link: "https://conciergewellness.janeapp.com/locations/downtown-colorado-springs/book#/staff_member/1/treatment/10",
  });
  const [isOpen, setIsOpen] = useState(false);

  //controls modal pop up
  useEffect(() => {
    //10 seconds
    const timeoutId = setTimeout(() => {
      setIsOpen(true);
    }, 10000);
    return () => clearTimeout(timeoutId);
  }, []);

  // check if there's a hash in the URL
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",

            name: "Concierge Wellness",

            url: "https://conciergewellnesspt.com",

            image: "https://conciergewellnesspt.com/icon.png",

            description:
              "Physical therapy and massage therapy services in Colorado Springs focused on movement, recovery, and performance.",

            telephone: "+1-719-247-2207",

            address: {
              "@type": "PostalAddress",
              streetAddress: "324 E Pikes Peak Ave Ste 100",
              addressLocality: "Colorado Springs",
              addressRegion: "CO",
              postalCode: "80903",
              addressCountry: "US",
            },

            areaServed: "Colorado Springs",

            sameAs: ["https://www.instagram.com/concierge_wellness"],
          })}
        </script>

        <title>
          Concierge Wellness | Physical Therapy & Massage Therapy in Colorado
          Springs
        </title>
        <meta
          name="description"
          content="Concierge Wellness provides personalized physical therapy and massage therapy in Colorado Springs. Move better, recover faster, and perform at your best with one-on-one care tailored to your goals."
        />

        <meta
          name="keywords"
          content="physical therapy Colorado Springs, massage therapy Colorado Springs, sports rehabilitation, manual therapy, sports massage, concierge wellness, movement recovery performance, physical therapist Colorado Springs, massage therapist Colorado Springs"
        />

        <meta name="robots" content="index,follow" />

        {/* Canonical */}
        <link rel="canonical" href="https://conciergewellnesspt.com" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />

        <meta property="og:url" content="https://conciergewellnesspt.com" />

        <meta
          property="og:title"
          content="Concierge Wellness | Physical Therapy & Massage Therapy in Colorado Springs"
        />

        <meta
          property="og:description"
          content="Move better, recover faster, and perform at your best with personalized physical therapy and massage therapy in Colorado Springs."
        />

        <meta property="og:site_name" content="Concierge Wellness" />

        <meta
          property="og:image"
          content="https://conciergewellnesspt.com/icon.png"
        />

        {/* Twitter / X */}
        <meta name="twitter:card" content="summary_large_image" />

        <meta
          name="twitter:title"
          content="Concierge Wellness | Physical Therapy & Massage Therapy in Colorado Springs"
        />

        <meta
          name="twitter:description"
          content="Move better, recover faster, and perform at your best with personalized physical therapy and massage therapy in Colorado Springs."
        />

        <meta
          name="twitter:image"
          content="https://conciergewellnesspt.com/icon.png"
        />
      </Helmet>

      <main className="main-container">
        {/* hero section */}
        <Hero />

        {/* testimonial section */}
        <Testimonials />

        {/* parallax 1, works on iOS as well */}

        <div
          class="parallax-fixed-bg"
          title="Photo by Victor Freitas on Unsplash "
          alt="Weight Lifter"
        >
          <div class="parallax-wrap">
            <div class="parallax"></div>
          </div>
        </div>

        {/* the process/cards section */}
        <MainContent />

        {/* call button */}
        <CallButton />

        {/* parallax 2 */}
        <div
          class="parallax-fixed-bg parallax-margin"
          title="Photo by Kelly Sikkema on Unsplash "
          alt="Fitness Bands"
        >
          <div class="parallax-wrap">
            <div class="parallax2"></div>
          </div>
        </div>

        {/* google map */}
        <Map />

        {/* partners section */}
        <Partners />

        {/* pop up  */}
        {isOpen && (
          <Modal
            setIsOpen={setIsOpen}
            submissionStatus={submissionStatus}
            setSubmissionStatus={setSubmissionStatus}
          />
        )}
      </main>
    </>
  );
};

export default HomeScreen;
